// /**
//  * Bundle - list
//  */

// React
import React, {useContext, useEffect} from 'react';
import {Link} from 'react-router-dom';
import HeaderBuilder from '../../../../utils/headerBuilder';
// Context
import AuthContext from '../../../../authContext';

// UI
import theme from '../../../../theme';
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles,
} from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  IconButton,
  FormControlLabel,
  FormControl,
  RadioGroup,
  Radio,
  Select,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiFileDocumentOutline,
  mdiPencilOutline,
  mdiCreditCardOutline,
} from '@mdi/js';

// Components
import Can from '../../../../components/Can';

// Helper
import {
  checkMatchMedia,
  numberWithCommas,
  translate,
} from '../../../../utils/helpers';
import jMoment from 'moment-jalaali';
import stableSort from '../../../../utils/Table/stableSort';
import getComparator from '../../../../utils/Table/getComparator';
import {PackageType, CountOrderIdPair, ReportOrderItem} from '../../interfaces';
import {dsiDetails} from '../../../../components/icons/customIcons';
// Type
// import {Bundle} from './interfaces';

type Data = Bundle;
type Props = {
  data: any;
  handleClickOpen: (id: number) => void;
  changeStatus: any;
  handleOpenEdit: (id: number) => void;
  handleOpenOrders?;
  count?: CountOrderIdPair[];
};

type Ord = 'asc' | 'desc';

// Style
const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: 'rgba(190, 194, 211, 1) !important',
      color: theme.palette.common.white,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      '@media (max-width: 768px)': {
        fontSize: 10,
      },
    },
    body: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontSize: 14,
    },
  })
)(TableCell);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    paper: {
      width: '100%',
    },
    table: {
      // minWidth: 750,
    },
    head: {
      backgroundColor: 'rgba(190, 194, 211, 1) !important',
      color: theme.palette.common.white,
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
    container: {
      maxHeight: 540,
      borderRadius: '4px',
    },
    // Fully visible for active icons
    activeSortIcon: {
      opacity: 1,
      color: `${theme.palette.secondary.main}!important`,
    },
    // Half visible for inactive icons
    inactiveSortIcon: {
      opacity: 0.4,
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
  })
);

// const
//
// const invoicesStatus = [
//   'CREATED',
//   'PAID',
//   'NOT_PAID'
// ];

export default function EnhancedTable(props: Props) {
  const authContext = useContext(AuthContext);
  const classes = useStyles();
  const [order, setOrder] = React.useState<Ord>('desc');
  const [orderBy, setOrderBy] = React.useState<keyof Data>('id');

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleGetConsumingOrders = () => {
    props.handleOpenOrders();
    //open the modal
    //handle get and populate data
    //handle click away
    //handle side-effects
  };

  return (
    <div className={classes.root}>
      <TableContainer component={Paper}>
        <Table
          stickyHeader
          className={classes.table}
          aria-labelledby="tableTitle"
          size={checkMatchMedia('(max-width: 1024px)') ? 'small' : 'medium'}
          aria-label="enhanced table"
        >
          <HeaderBuilder
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            rowCount={props.data?.length}
            filterVal={props.filterVal}
            onFilterValue={(filtervalues: any) => {
              props.onFilterValue(filtervalues);
            }}
            head={props.head}
            removeFilterHandler={props.removeFilterHandler}
            haveAction={false}
            filterLabelTranslator={props.filterLabelTranslator}
          />
          <TableBody>
            {stableSort(props.data, getComparator(order, orderBy))
              .slice()
              .map((row: ReportOrderItem, index: number) => {
                const labelId = `enhanced-table-checkbox-${index}`;
                return (
                  <TableRow key={index}>
                    <StyledTableCell align="center">{row.id}</StyledTableCell>
                    <StyledTableCell align="center">
                      {row.trackingCode}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {translate(row.status, 'order')}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {row.packageCount}
                    </StyledTableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
